export const pageNavigationIds = {
  GIFT_INFO: 'gift-info',
  GIFT_DETAIL: 'gift-detail',
  SPECIFICATION: 'specification',
  NOTICE: 'notice'
}

export const pageNavigationItems = [
  { id: pageNavigationIds.GIFT_INFO, label: 'ギフト情報' },
  { id: pageNavigationIds.GIFT_DETAIL, label: 'ギフト詳細' },
  { id: pageNavigationIds.SPECIFICATION, label: '商品仕様' },
  { id: pageNavigationIds.NOTICE, label: '注意事項' }
]
